import { Outlet } from 'react-router-dom';
import { Box, useBreakpointValue } from '@chakra-ui/react';
import { useAppSelector } from '../../redux/hooks';
import { LandingScreen } from '../../screens';
import { TopNavbar } from '../common/navbar/top-navbar.component';
import { MobileRedirect } from '../../mobileRedirect';
import { SidebarInset, SidebarProvider } from '../ui/sidebar';
import { AppSidebar } from '../common/navbar/sidebar/app-sidebar';

export const Layout = () => {
  const initialIsDesktop = window.innerWidth >= 450;
  const breakpointValue = useBreakpointValue({ base: false, md: true });
  const isDesktop = breakpointValue ?? initialIsDesktop;
  const { isLoggedIn } = useAppSelector((state) => state.user);
  

  if (!initialIsDesktop) {
    return <MobileRedirect />;
  }

  if (!isLoggedIn) {
    return <LandingScreen />;
  }

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <TopNavbar />
        <Box as="main">
          <Box className="scrollable-content">
            <Outlet />
          </Box>
        </Box>
      </SidebarInset>
    </SidebarProvider>
  );
};
